import React, { Component } from 'react'
import { Container, Row, Col, Tabs, Tab, } from 'react-bootstrap'
import Footer from './Footer'
import HeaderTop from './HeaderTop'
import SideNavTop from './SideNavTop'
import '../Accueil.css'


class SauveSport extends Component {
    state = {
        redirect: false,
        search: '',
        key: 'maitre'
    }

    handleCHange = event => {
        const { name, value } = event.target
        this.setState({ [name]: value })
    }

    handleSubmit = event => {
        //on gere le form
        event.preventDefault()
        this.props.history.push(`/recherche/${this.state.search}`);

    }

    setRedirect = () => {
        this.setState({
          redirect: true
        })
      }

    handleSubmitFacebbok = () => {
        if (this.state.redirect) {
            window.location.href = "https://www.facebook.com/clubCAPN/";
        }
    }

    handleSelect(key) {
        if (key === "maitre")
            this.props.history.push(`/competiton/maitres-nageurs`);
        else if (key === "natation")
            this.props.history.push(`/competiton/natation`);
        else if (key === "sauvetage")
            this.props.history.push(`/competiton/sauvetage-sportif`);
        else if (key === "resultat")
            this.props.history.push(`/competiton/resultats`);
        else if (key === "synchro")
            this.props.history.push(`/competiton/nage-synchronisee`);
    }

    render() {
        console.log(this.state.key)
        return (
            <>
                <Container fluid>
                <Row>
            <SideNavTop/>
            <Col lg={10} md={12} sm={12} xs={12} id="page-content-wrapper" className="nopadding">
              <HeaderTop
                handleSubmit={this.handleSubmit}
                handleCHange={this.handleCHange}
                handleSubmitFacebbok={this.handleSubmitFacebbok}
                setRedirect={this.setRedirect}
              />

                            <Col lg={12} md={12} sm={12} xs={12} className="nopadding">

                                <Tabs
                                    id="controlled-tab"
                                    activeKey={this.state.key}
                                    onSelect={key => this.handleSelect(key)}
                                >                       <Tab eventKey="maitre" title="Maître Nageurs">
                                    </Tab>
                                    <Tab eventKey="synchro" title="Nage synchronisée">
                                    </Tab>
                                    <Tab eventKey="natation" title="Natation" >
                                    </Tab>
                                    <Tab eventKey="sauvetage" title="Sauvetage sportif">
                                    </Tab>
                                    <Tab eventKey="resultat" title="Résultats des compétitions" >
                                    </Tab>
                                </Tabs>
                            </Col>


                            <Col lg={12} md={12} sm={12} xs={12} className="nopadding">
                                <Row>
                                    <Col lg={12} md={12} sm={12} xs={12} className="nopadding">
                                        <div className="histoire-content">
                                            <h1><span>Sauvetage sportif - Saison 2020-2021</span></h1>
                                            <h2>INFORMATIONS</h2>
                                            <p className="pCenter">Notre Club de sauvetage sportif est des plus dynamiques. Le sauvetage sportif permet de pratiquer
                                                 des techniques de premiers soins, de sauvetage et de natation en vue de compétitions régionales,
                                                  provinciales et nationales. Les jeunes sauveteurs et  les sauveteurs seniors peuvent donc développer leur esprit d'équipe,
                                                   leur capacité d'analyse en situation d'urgence, leur endurance physique et leur sens de l'organisation.

                                            Pour des infromations supplémentaires veuillez communiqué avec l'entraîneur-chef au <strong>infosauvetage.capn@gmail.com</strong><br /><br />
                                            </p>

                                            <p className="pCenter"><strong>Inscriptions:</strong> 2 septembre 2020<br />

                                            <strong>Début des entraînements:</strong> 21 septembre 2020<br />

                                            Prendre note qu'il y aura arrêt des entraînements pour la période des fêtes du 19 décembre 2020 au 
                                            3 janvier 2021 inclusivement ainsi que la semaine de relâche.<br /><br /></p>

                                            <h2>GROUPE DE COMPÉTITION</h2>
                                            <p className="pCenter"> <strong>JUNIOR et SENIORR </strong>- 4 heures d'entrainement par semaine<br />
                                            <strong>Pré-requis :</strong> Junior 5 complété<br />
                                            <strong>Coût :</strong> 330 $<br />
                                            <strong> Durée :</strong> 21 septembre 2020 au 12 juin 2021<br /></p>
 
                                            <p  className="pCenter"><i>
                                            * Les frais de compétitions et d'affiliation ne sont pas compris dans les frais d'inscription. L'inscription comprend un casque de bain du club.</i><br /></p>

                                            
                                            <h2>HORAIRE D'ENTRAINEMENT</h2>
                                            <p className="pCenter">Lundi de 18h45 à 20h15<br />
                                            Jeudi de 17h30 à 19h00<br /></p>
                                            
                                            
                                            <p  className="pCenter"><i>*** Tous les horaires sont sujets à changement au courant de la saison.</i></p>

                                            <div className="pCenter">
                                                <p className="pCenter"> Lien<br/></p> <a className="link-history" href="https://www.fnq.qc.ca">Fédération de natation du Québec</a><br/>
                                                <a className="link-history" href="https://www.mymsc.ca">Maîtres-nageurs du Canada</a>
                                            </div>
                                        </div>
                                    </Col>
                                </Row>
                            </Col>

                            <Col lg={12} md={12} sm={12} xs={12} className="nopadding">
                                <Footer />
                            </Col>
                        </Col>
                    </Row>
                </Container>
            </>
        )
    }
}

export default SauveSport
